export default __webpack_public_path__ + "static/media/option-add.4a9cc69f.png";